export default {
  booking: {
    title: '预订信息',
    bookingTitle: '预订标题',
    seatType: '座位类型',
    attendanceDate: '参加日期',
    participationTime: '参加时间',
    trainModel: '车型',
    seatInfo: '座位',
    reservationCount: '预订数量',
    viewDetail: '查看详情',
    bookingRange: {
      oneMonth: '1个月内的预订',
      threeMonths: '3个月内的预订',
      sixMonths: '6个月内的预订'
    },
    adultTicket: '成人票',
    childTicket: '儿童票',
    status: {
      paymentPending: '待支付',
      paid: '订票中，请稍候',
      confirmed: '订票成功，已出票',
      cancelPending: '取消中',
      cancelled: '已取消',
      refunded: '已退款',
      paymentExpired: '支付过期',
      completed: '已完成',
      confirmFailed: '确认失败'
    }
  },
  bookingDetail: {
    title: '订单详情',
    travelInfo: '出行信息',
    digitalTicket: '电子票券',
    meetingPoint: '集合或兑换地点说明',
    beforeTrip: '行前须知',
    bookingAction: '订单操作',
    cancelBooking: '取消订单',
    cancelConfirmPolicy: '请确认取消政策：',
    cancelTip:
      '出票后如需取消订单请在乘车时间1小时前操作，否则无法取消退款，请知悉。',
    sendToEmail: '发到邮箱',
    attendanceDate: '参加日期',
    customerName: '预约姓名',
    email: '邮箱',
    actualPayment: '实付金额',
    orderId: '订单ID',
    orderCompletionTime: '订单完成时间',
    digitalTicketValidPeriod: '二维码仅限乘车当日有效',
    digitalTicketWaiting: '*订单确认后，电子票券将会在此处显示',
    sending: '发送中...',
    sendToEmailSuccess: '发送成功，请去邮箱查收'
  }
};
